import { render, staticRenderFns } from "./FlapsCustomerLevelChangeForm.vue?vue&type=template&id=3ca88dcb&scoped=true&"
import script from "./FlapsCustomerLevelChangeForm.vue?vue&type=script&lang=js&"
export * from "./FlapsCustomerLevelChangeForm.vue?vue&type=script&lang=js&"
import style0 from "./FlapsCustomerLevelChangeForm.vue?vue&type=style&index=0&id=3ca88dcb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca88dcb",
  null
  
)

export default component.exports